import './measure-list.css'
import { useStore } from "../state/state.ts";
import type { MeasureWidget } from "../state/types.ts";
import { clsx } from "../functions.ts";
import React from "react";
import MeasureWidgetBase from "./measure-widgets/measure-widget-base.tsx";
import MeasureWidgetDach from "./measure-widgets/measure-widget-dach.tsx";
import MeasureWidgetFassade from "./measure-widgets/measure-widget-fassade.tsx";
import MeasureWidgetFenster from "./measure-widgets/measure-widget-fenster.tsx";
import MeasureWidgetHeizung from "./measure-widgets/measure-widget-heizung.tsx";
import MeasureWidgetKeller from "./measure-widgets/measure-widget-keller.tsx";
import MeasureWidgetLueftung from "./measure-widgets/measure-widget-lueftung.tsx";
import MeasureWidgetPhotovoltaik from "./measure-widgets/measure-widget-photovoltaik.tsx";
import MeasureWidgetSolarthermie from "./measure-widgets/measure-widget-solarthermie.tsx";
import MeasureWidgetKostengrundlage from "./measure-widgets/measure-widget-kostengrundlage.tsx";

export default function MeasureList() {
  const selected_menu_item = useStore((state) => state.selected_menu_item);
  const keep_menu_open = useStore((state) => state.keep_menu_open);
  return (
    <>
    <div className={clsx('measure-list', (selected_menu_item || keep_menu_open) && 'measure-list--hidden')}>
      <MeasureWidgetBase />
      <MeasureWidgetHeizung />
      <MeasureWidgetKeller />
      <MeasureWidgetDach />
      <MeasureWidgetFenster />
      <MeasureWidgetFassade />
      <MeasureWidgetSolarthermie />
      <MeasureWidgetPhotovoltaik />
      <MeasureWidgetLueftung />
     </div>
    </>
  )
}